"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localLogger = exports.ProductListContainer = void 0;
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _ProductList = require("../../components/ProductList/ProductList");
var _constantsGenerated = require("../../constants-generated");
var _productListContext = require("../../contexts/productListContext");
var _logger2 = require("../../logger");
var _ProductListContainerSkeleton = require("../ProductListContainerSkeleton");
var _components = require("./components");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve --container */

const localLogger = exports.localLogger = _logger2.mainLogger.createChild('ProductList');
const ProductListContainer = ({
  translations,
  withTranslationsProvider = true,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
  team: _testidGenerator.Team.Presentation,
  project: _constantsGenerated.APP_NAME,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: withTranslationsProvider ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductListContainerSkeleton.ProductListSkeleton, {
      ...props
    }) : null,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
      logger: _logger2.mainLogger,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
        logger: localLogger,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ProductListWithTranslations, {
          translations: translations,
          withTranslationsProvider: withTranslationsProvider,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_productListContext.ProductListProvider, {
            value: props,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductList.ProductList, {})
          })
        })
      })
    })
  })
});
exports.ProductListContainer = ProductListContainer;
